<div class="container-fluid default-block-padding">
    <div class="row">
        <div class="col-12">
            <div class="title text-center" [innerHTML]="data.title | bypassSecurity"></div>
        </div>
    <div class="row mt-4">
        <div class="col-lg-4" *ngFor="let article of data.articles">
            <!-- Mobile/tablet: regular img tag -->
            <img [src]="article.image?.url" [alt]="article.image?.alternativeText" class="img-fluid mb-3 default-border-radius-sm d-lg-none" />
            <!-- Large screens: img-box with background -->
            <div class="img-box d-none d-lg-block mb-3" [style.background-image]="'url(' + article.image?.url + ')'" [attr.aria-label]="article.image?.alternativeText"></div>
            <h3>{{ article.title }}</h3>
            <div class="description">{{ article.description }}</div>
            <a href="{{article.link?.url}}" target="{{article.link?.openInNewTab ? '_blank' : '_self'}}" >{{article.link?.text}}</a>
        </div>
    </div>
</div>